import React from "react";
import { useCurrentUser } from "./useCurrentUser";

import { useSignInAsMutation } from "../components/auth/mutations/SignIn";
import { UserRole } from "../constants";

export function useSwitchUser(redirect: boolean = true) {
  const me = useCurrentUser();
  const wasImpersonating = me?.isImpersonating;
  const isSample = me?.isSample;

  const switchingToCoachRef = React.useRef(false);

  const { mutate: signInAs } = useSignInAsMutation({
    redirect,
    wasImpersonating,
    get switchingToCoach() {
      return switchingToCoachRef.current;
    },
    switchingFromSample: isSample,
  });

  const switchUser = React.useCallback(
    (userId?: number, userRole?: string) => {
      const isCoach = userRole === UserRole.COACH;
      switchingToCoachRef.current = isCoach;

      // If no userId is provided, switch back to the original user, or throw error if not impersonating
      signInAs({
        desiredUserId: userId,
      });
    },
    [signInAs],
  );

  return switchUser;
}
